module.exports = "<button mat-raised-button color=\"primary\" (click)=\"logout()\">Logout</button>\n"


//////////////////
// WEBPACK FOOTER
// /Users/traev/Sites/btt/src/app/components/logout/logout.component.html
// module id = ../../../../../src/app/components/logout/logout.component.html
// module chunks = main